// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__2pHfJ","left":"Footer_left__erWrF","right":"Footer_right__2X7SN","disabled":"Footer_disabled__ZNXNI"};